import { render, staticRenderFns } from "./WxAppConfigDesc.vue?vue&type=template&id=6185a37b"
import script from "./WxAppConfigDesc.vue?vue&type=script&lang=js"
export * from "./WxAppConfigDesc.vue?vue&type=script&lang=js"
import style0 from "./WxAppConfigDesc.vue?vue&type=style&index=0&id=6185a37b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports